import { Component, OnInit } from '@angular/core';
import { ResourceService, CalendarLanguagueService, UserService } from '../../../../services/index.service';
import { ResponseDataBase } from '../../../../interfaces/index.interface';
import { AppConstants } from '../../../../appConstants';
import { FormGroup, FormControl } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'deleted-users-page',
  templateUrl: './deleted-users.page.html'
})
export class DeletedUsersPage implements OnInit {
  alert;
  deletedUsers;
  searchForm: FormGroup;

  constructor(public _resourceService: ResourceService, public _userService: UserService,
    public locale: CalendarLanguagueService) {
    this.searchForm = new FormGroup({
      'datefrom': new FormControl(moment('2020-01-01').toDate()),
      'dateto': new FormControl(new Date),
      'filter': new FormControl(),
    });
  }


  getDeletedUsers() {
    let params: any = {};
    if (this.searchForm.value.filter == "yes") {
      let formatedDateTo = moment(this.searchForm.value.dateto, "DD-MM-YYYY").format('YYYY-MM-DD');
      let formatedDateFrom = moment(this.searchForm.value.datefrom, "DD-MM-YYYY").format('YYYY-MM-DD');
      params.dateto = formatedDateTo;
      params.datefrom = formatedDateFrom;
    };
    this._userService.getDeletedUsers(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        if (!response.result.length) {
          this.alert = 'NO_RESULTS'
        } else {
          this.deletedUsers = response.result;
        }
      } else {
        this.alert = response.METADATA.ERROR_MESSAGE;
      }
      this._resourceService.loading = false;
    });
  }

  clearDeletedUsers() {
    delete this.deletedUsers;
  }

  print() {
    window.print();
  }

  ngOnInit(): void {
  }

}
